import { render, staticRenderFns } from "./PgSettingIframe.vue?vue&type=template&id=b549e832&"
import script from "./PgSettingIframe.vue?vue&type=script&lang=ts&"
export * from "./PgSettingIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports